import React from 'react';
import { FiltersProvider } from './FiltersProvider';
import { ScriptErrorDetails } from './ScriptErrorDetails';

export default () => {
  return (
    <FiltersProvider>
      <ScriptErrorDetails />
    </FiltersProvider>
  );
};
